export const Environment = {
  baseUrl: process.env.REACT_APP_BASE_URL ?? '',
  envName: process.env.NODE_ENV ?? 'production',
  hideMarks: process.env.REACT_APP_HIDE_MARKS === 'false',
  Country: process.env.REACT_APP_COUNTRY ?? 'NI',
  APKFileName: process.env.REACT_APP_APK_FILE_NAME ?? 'Karthus v3.0.2 SV Demo [Impressa].apk',
} as const;
